var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferralEraser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.0901 66H41.97C40.71 66 39.72 64.98 39.72 63.75C39.72 62.52 40.74 61.5 41.97 61.5H63.0901C64.3501 61.5 65.3401 62.52 65.3401 63.75C65.3401 64.98 64.3501 66 63.0901 66Z",
    fill: "#437ADB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M46.2299 49.0202L31.9799 63.2702C28.6499 66.6002 23.3101 66.7802 19.7701 63.8102C19.5601 63.6302 19.3801 63.4502 19.2001 63.2702L16.5901 60.6602L11.22 55.2902L8.64 52.7102C8.43 52.5002 8.24999 52.2902 8.06999 52.0802C5.12999 48.5402 5.34 43.2602 8.64 39.9602L19.71 28.9202L22.89 25.7402L46.2299 49.0202Z",
    fill: "#C7D7F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.36 31.9198L46.2299 49.0198L22.89 25.7398L40.0201 8.63982C43.5301 5.12982 49.2899 5.12982 52.7999 8.63982L63.36 19.1698C66.87 22.6798 66.87 28.4098 63.36 31.9198Z",
    fill: "#437ADB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralEraser);
export default __webpack_public_path__ + "static/media/referral-eraser.11ece1291e2bf0fedecdf90857f45069.svg";
export { ForwardRef as ReactComponent };